export default "__VITE_ASSET__C$pfp8il__"